/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import * as apiErrorService from '../services/apiErrorService'
import { CSVLink } from 'react-csv';
import * as _ from 'lodash'
let linkClick
class ApiError extends Component {
   csvLink = React.createRef();
   constructor(props) {
      super(props);
      this.state = {
         keys_list: [],
         paths_list: [],
         statuses_list: [],
         keys: '',
         paths: '',
         statuses: '',
         errors_data: [],
         csv_json: [],
         errors_search_data: [],
         last_id: "",
         first_id: "",
         action: "",
         from: "",
         to: "",
         page_no: 1,
         count_records: 0,
         records_display: 25

      };
   }

   async componentDidMount() {
      let logKeys = await apiErrorService.getApiError()
      this.setState({ keys_list: logKeys.keys })
      this.setState({ paths_list: logKeys.paths })
      this.setState({ statuses_list: logKeys.statuses })
      let curDate = new Date().toISOString().split('T')[0]
      let weekDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]
      this.setState({ to: curDate, from: weekDate }, () => { this.submitForm() })
   }
   componentWillUnmount(){
      clearTimeout(linkClick)
   }
   parseFilterBody() {
      let toDate = new Date(this.state.to)
      toDate = toDate.setHours(23, 59, 59, 999)
      let fromDate = new Date(this.state.from)
      fromDate = fromDate.setHours(0, 0, 0, 0)
      let body = {
         "filters": {
            "keys": [this.state.keys],
            "paths": [this.state.paths],
            "statuses": [this.state.statuses]
         },
         "last_id": this.state.last_id,
         "first_id": this.state.first_id,
         "action": this.state.action,
         "from": new Date(fromDate).toISOString(),
         "to": new Date(toDate).toISOString(),
         "page_no": this.state.page_no,
         "count_records": this.state.count_records,
         "records_display": this.state.records_display
      }
      body = this.clean(body);
      return body
   }
   async submitForm() {
      const self = this;
      let body = this.parseFilterBody()
      await apiErrorService.postApiError(body).then((res) => {
         console.log(res.items)
         if (res.isSuccess) {
            self.setState(
               {  
                  errors_data: res.items,
                  errors_search_data: res.items,
                  last_id: res.last_id,
                  first_id: res.first_id,
                  action: res.action,
                  page_no: res.page_no,
                  count_records: res.count_records
               }
            );
         } else {
            this.setState({ from: "", to: "", errors_data: [], errors_search_data: [], last_id: "", first_id: "", action: "", page_no: 1, count_records: 0 })
         }
      })
   }
   async onDownload() {
      const self = this;
      let body = this.parseFilterBody()
      await apiErrorService.postApiErrorCsv(body).then((res) => {
         this.setState({ csv_json: res }, () => {
            linkClick = setTimeout(function () {
               clearTimeout(linkClick)
               self.csvLink.current.link.click();
            }, 500)

         })
      })
   }
   clean(obj) {
      for (var propName in obj) {
         if (obj[propName] === undefined) {
            delete obj[propName];
         }
      }
      return obj
   }
   onAction(e) {
      const value = e.target.name;
      let page_n = 0;
      if (value === "next") {
         page_n = this.state.page_no + 1;
      }
      if (value === "prev") {
         page_n = this.state.page_no - 1;
      }
      this.setState({ action: value, page_no: page_n }, () => { this.submitForm(); });

   }
   resetForm() {
      let curDate = new Date().toISOString().split('T')[0]
      let weekDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]
      this.setState({ keys: '', paths: '', statuses: "", from: weekDate, to: curDate, errors_data: [], errors_search_data: [], last_id: "", first_id: "", action: "", page_no: 1, count_records: 0 })
   }
   onSubmit(e) {
      let diffTime = Math.abs(new Date(this.state.to) - new Date(this.state.from))
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays > 31) {
         alert("Date range must be 1 month.")
      }
      else {
         this.setState({ action: "", page_no: 1 }, () => { this.submitForm(); });
      }
   }
   onDelete() {
      if (window.confirm("Are you sure for delete ????")) {
         this.setState({ action: "delete", page_no: 1 }, () => { this.submitForm(); });
      }
   }
   onChange(e) {
      const name = e.target.name;
      const value = e.target.value;
      if (name === "records_display") {
         this.setState({ [name]: value }, () => { this.submitForm() });
      }
      else {
         this.setState({ [name]: value });
      }
   }
   onSearch(e) {
      const value = e.target.value;
      if (this.state.errors_search_data) {
         let errors_lst = _.filter(this.state.errors_search_data, function (obj) {
            return JSON.stringify(obj).indexOf(value) !== -1;
         });
         this.setState({ errors_data: errors_lst });
      }
   }
   render() {
      return (
         <div className="bethubs">
            <Header history = {this.props.history} />
            <div className="wrapper">
               <div className="w3-sidebar w3-bar-block w3-border-right" style={{ "display": "none" }} id="mySidebar">
                  <ul>
                     <li><a href="list-of-clients.html">List of Clients</a></li>
                     <li><a href="#">Market Analysis</a></li>
                     <li><a href="import-event.html">Import Event</a></li>
                     <li>
                        <a href="#homeSubmenu" data-toggle="collapse" aria-expanded="true" className="dropdown-toggle"> Live Markets </a>
                        <ul className="list-unstyled collapse" id="homeSubmenu" >
                           <li><a href="#">Test 1</a></li>
                        </ul>
                     </li>
                     <li>
                        <a href="#home1Submenu" data-toggle="collapse" aria-expanded="true" className="dropdown-toggle"> Reports</a>
                        <ul className="list-unstyled collapse" id="home1Submenu" >
                           <li><a href="#">Test 1</a></li>
                           <li><a href="#">Test 1</a></li>
                        </ul>
                     </li>
                  </ul>
               </div>
               <div className="container-fluid container-padding-0">
                  <div className="row">
                     <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="main-box">
                           <h5 className="text-blue">Logging Report</h5>
                           <div className="row mt-2">
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                 <div className="form-group font-12">
                                    <select onChange={(e) => this.onChange(e)} title="Keys" className="form-control" name="keys" value={this.state.keys}>
                                       <option>Select Keys</option>
                                       {this.state.keys_list.length > 0 ? this.state.keys_list.map((key, i) => <option key={i} value={key === null ? "null" : key === '' ? "blank" : key}>{key === null ? "null" : key === '' ? "blank" : key}</option>) : ""}
                                    </select>
                                 </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                 <div className="form-group font-12">
                                    <select onChange={(e) => this.onChange(e)} title="Paths" className="form-control" name="paths" value={this.state.paths}>
                                       <option>Select Paths</option>
                                       {this.state.paths_list.length > 0 ? this.state.paths_list.map((path, i) => <option key={i} value={path === null ? "null" : path === '' ? "blank" : path}>{path === null ? "null" : path === '' ? "blank" : path}</option>) : ""}
                                    </select>
                                 </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                 <div className="form-group font-12">
                                    <select onChange={(e) => { this.onChange(e) }} title="Statuses" className="form-control" name="statuses" value={this.state.statuses}>
                                       <option value={""}>Select Statuses</option>
                                       {this.state.statuses_list.length > 0 ? this.state.statuses_list.map((statuses, i) => <option key={i} value={statuses.id}>{statuses.name}</option>) : ""}
                                    </select>
                                 </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                 <div className="form-group font-12">
                                    <input className="form-control" value={this.state.from} title="From" type="date" onChange={(e) => this.onChange(e)} id="from_datetime" name="from" />
                                 </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                 <div className="form-group font-12">
                                    <input className="form-control" value={this.state.to} title="To" type="date" onChange={(e) => this.onChange(e)} id="to_datetime" name="to" />
                                 </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                 <div className="btn-group" role="group" aria-label="Basic example" id="divpagecount">
                                    <button className="btn btn-blue" onClick={(e) => this.onSubmit(e)}>Go</button>
                                    <button className="btn btn-blue ml-1" onClick={(e) => this.resetForm()}>Reset</button>
                                    <button className="btn btn-blue ml-1" onClick={(e) => this.onDelete()}>Delete</button>
                                 </div>
                              </div>
                           </div>
                           <div className="row text-center my-2">
                              <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                 <span className="d-inline search-report">Show</span>
                                 <div className="form-group font-12 float-left mb-0">
                                    <select onKeyPress={(e) => this.onAction(e)} onChange={(e) => { this.onChange(e) }} className="form-control" name="records_display" value={this.state.records_display}>
                                       <option value="25">25</option>
                                       <option value="50">50</option>
                                       <option value="100">100</option>
                                    </select>
                                 </div>
                                 <span className="d-inline search-report ml-2">entries</span>
                              </div>
                              <div className="col-12 col-sm-12 col-md-6 col-lg-6 mt-1">
                                 <div className="d-flex float-right">
                                    <CSVLink
                                       data={this.state.csv_json}
                                       filename={"Logging-Report.csv"}
                                       asyncOnClick={true}
                                       className="d-none"
                                       ref={this.csvLink}>
                                    </CSVLink>
                                    <button className="btn btn-dark btn-sm mr-2 d-inline" onClick={(e) => this.onDownload(e)} disabled={this.state.errors_data.length > 0 ? false : true}><i className="fa fa-file-excel-o" aria-hidden="true"></i></button>
                                    <div className="form-group mb-0 d-inline">
                                       <input className="form-control" onChange={(e) => { this.onSearch(e) }} type="text" placeholder="Search" aria-label="Search" />
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div className="row">
                              <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                 <div className="table-responsive">
                                    <table id="basic-btn" className="table font-14 table-bordered table-sm">
                                       <thead>
                                          <tr className="bg-dark text-white">
                                             <th>Key</th>
                                             <th>Method</th>
                                             <th>Path</th>
                                             <th>QueryString</th>
                                             <th>ContentType</th>
                                             <th>Payload</th>
                                             <th>Status</th>
                                             <th>Code</th>
                                             <th>Message</th>
                                             <th>Time</th>
                                          </tr>
                                       </thead>
                                       <tbody>
                                          {this.state.errors_data.length > 0 ? this.state.errors_data.map((user, i) => {
                                             let dt = new Date(user.time).toLocaleString()
                                             return (
                                                <tr key={i}>
                                                   <td className="text-success">{user.key ? user.key : "-"}</td>
                                                   <td>{user.method ? user.method : "-"}</td>
                                                   <td className="text-success">{user.path ? user.path : "-"}</td>
                                                   <td>{user.queryString ? user.queryString : "-"}</td>
                                                   <td>{user.contentType ? user.contentType : "-"}</td>
                                                   <td>{user.payload ? user.payload : "-"}</td>
                                                   <td className="text-success">{user.status ? user.status : "-"}</td>
                                                   <td>{user.code ? user.code : "-"}</td>
                                                   <td>{user.message ? user.message : "-"}</td>
                                                   <td>{dt ? dt : "-"}</td>
                                                </tr>
                                             );
                                          }) : <tr>
                                                <td colSpan={14} align="center">
                                                   No Data Found.
                                          </td>
                                             </tr>}
                                       </tbody>
                                    </table>
                                 </div>
                                 <div className="row text-right">
                                    <div className="col-sm-12 col-md-12">
                                       <div className="btn-group my-2" role="group" aria-label="Basic example" id="divpagecount">
                                          <button type="button" className="btn btn-blue" id="PrevPage" name="prev" onClick={(e) => this.onAction(e)} disabled={this.state.first_id === "" ? true : false}>Prev</button>
                                          <button className="btn btn-blue" disabled>
                                             {
                                                this.state.page_no
                                             }
                                          </button>
                                          <button type="button" className="btn btn-blue" id="NextPage" name="next" onClick={(e) => this.onAction(e)} disabled={this.state.last_id === "" ? true : false}>Next</button>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <Footer />
         </div>
      )
   }
}
function mapStateToProps(state) {
   return {
   };
}
function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(ApiError);